module.exports = __webpack_public_path__ + "static/media/no-listen-class3.44fda218.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/no-listen-class3.png
// module id = 1991
// module chunks = 6